import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getManagerProfile = async (config = {}) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/profile/`,
      {
        ...config,
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Manager profile fetch error:", error);
    throw error;
  }
};

const updateManagerProfile = async (data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/profile/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Manager profile update error:", error);
    throw error;
  }
};

const updatePageAccess = async (id, pageAccess) => {
  try {
    const token = getToken();

    const res = await axios.put(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/profile/page-access/?id=${id}`,
      { page_access: pageAccess },
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Page access update error:", error);
    throw error;
  }
};

const updateManagerAvatar = async (avatarFile) => {
  try {
    const token = getToken();

    const formData = new FormData();
    formData.append("avatar", avatarFile);

    const res = await axios.postForm(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/profile/avatar/`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return res;
  } catch (error) {
    console.error("Manager avatar update error:", error);
    throw error;
  }
};

const changeManagerPassword = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}fleet-manager/profile/change-password/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Password change error:", error);
    throw error;
  }
};

export {
  getManagerProfile,
  updateManagerProfile,
  updatePageAccess,
  updateManagerAvatar,
  changeManagerPassword,
};
